import {
  DateInputRenderer,
  type DateInputRendererProps,
  TextFieldRenderer,
  type TextFieldRendererProps,
  getRendererProps,
} from '@exam-center/components';
import { Flex, SectionTitle, Text } from '@shared/components';

import { ProctorEndedAtField, type ProctorEndedAtFieldProps } from '../proctor-ended-at-field';

export interface ProctorEmployeeInformationFieldsProps {
  fields: {
    startedAt: DateInputRendererProps;
    code: TextFieldRendererProps;
    position: TextFieldRendererProps;
    department: TextFieldRendererProps;
    isTerminationAssign: ProctorEndedAtFieldProps['fields']['isTerminationAssign'];
    endedAt: ProctorEndedAtFieldProps['fields']['endedAt'];
  };
  options?: ProctorEndedAtFieldProps['options'];
}

export default function ProctorEmployeeInformationFields(
  props: Readonly<ProctorEmployeeInformationFieldsProps>,
) {
  const { fields, options } = props;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <SectionTitle title='Employee Information' />
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text sx={{ flexBasis: '240px' }} variant='body1Semibold'>
          วันที่เริ่มปฏิบัติหน้าที่
        </Text>
        <Flex
          sx={{
            gap: (theme) => theme.spacing(4),
            flexDirection: 'column',
            flexBasis: '200px',
          }}
        >
          <DateInputRenderer
            {...getRendererProps(fields.startedAt, {
              label: 'วันที่เริ่มปฏิบัติหน้าที่',
              placeholder: 'DD-MM-YYYY',
              inputFormat: 'DD-MM-YYYY',
              required: true,
            })}
          />
        </Flex>
      </Flex>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text sx={{ flexBasis: '240px' }} variant='body1Semibold'>
          วันที่สิ้นสุดปฏิบัติหน้าที่
        </Text>
        <ProctorEndedAtField
          fields={{
            isTerminationAssign: fields.isTerminationAssign,
            endedAt: fields.endedAt,
          }}
          options={{
            shouldShowEndedAtDateDisplay: options?.shouldShowEndedAtDateDisplay,
          }}
        />
      </Flex>
      <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
        <Text sx={{ flexBasis: '240px' }} variant='body1Semibold'>
          ข้อมูลการปฏิบัติหน้าที่
        </Text>
        <Flex
          sx={{
            gap: (theme) => theme.spacing(4),
            flex: 1,
          }}
        >
          <TextFieldRenderer
            {...getRendererProps(fields.code, {
              label: 'รหัสพนักงาน',
              placeholder: 'กรอกรหัสพนักงาน',
              sx: { flexBasis: '200px' },
            })}
          />
          <TextFieldRenderer
            {...getRendererProps(fields.position, {
              label: 'ตำแหน่ง',
              placeholder: 'กรอกตำแหน่ง',
              sx: { flex: 1 },
            })}
          />
          <TextFieldRenderer
            {...getRendererProps(fields.department, {
              label: 'ฝ่ายงาน/ส่วนงาน',
              placeholder: 'กรอกฝ่ายงาน/ส่วนงาน',
              sx: { flex: 1 },
            })}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
